module.exports = function() {
  return new Worker(__webpack_public_path__ + "84bcc5cf7d20ca0aee1f.worker.js");
};